"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.HELP_BUTTON_CLICKED = exports.VISIT_ACCOUNT_MENU = exports.VISIT_INBOX = exports.VISIT_REFER_FRIEND = exports.VISIT_PREFERENCES = exports.VISIT_KIWICOM_CREDITS = exports.VISIT_PRICE_ALERTS = exports.VISIT_FARE_LOCKS = exports.VISIT_MY_TRIPS = void 0;
const VISIT_MY_TRIPS = {
  action: "visit my trips from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_MY_TRIPS = VISIT_MY_TRIPS;
const VISIT_FARE_LOCKS = {
  action: "visit fare locks from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_FARE_LOCKS = VISIT_FARE_LOCKS;
const VISIT_PRICE_ALERTS = {
  action: "visit price alerts from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_PRICE_ALERTS = VISIT_PRICE_ALERTS;
const VISIT_KIWICOM_CREDITS = {
  action: "visit kiwicom credits from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_KIWICOM_CREDITS = VISIT_KIWICOM_CREDITS;
const VISIT_PREFERENCES = {
  action: "visit account preferences from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_PREFERENCES = VISIT_PREFERENCES;
const VISIT_REFER_FRIEND = {
  action: "visit refer a friend from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_REFER_FRIEND = VISIT_REFER_FRIEND;
const VISIT_INBOX = {
  action: "visit inbox from navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_INBOX = VISIT_INBOX;
const VISIT_ACCOUNT_MENU = {
  action: "visit account menu when clicking on avatar in navbar",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.VISIT_ACCOUNT_MENU = VISIT_ACCOUNT_MENU;
const HELP_BUTTON_CLICKED = {
  action: "help button clicked",
  category: "general",
  destinations: {
    bigQuery: true,
    datadog: true,
    logmole: true
  }
};
exports.HELP_BUTTON_CLICKED = HELP_BUTTON_CLICKED;